import LzModal from './modal.vue';

LzModal.install = function(Vue) {
  Vue.component(LzModal.name, LzModal);
};

export default LzModal;
